import React, { memo } from 'react';
import BusinessFilterFormDefault from './views/default';
import BusinessFilterFormVoltz from './views/voltz';

const BusinessFilterForm = (params) => {
  const views = {
    default: <BusinessFilterFormDefault {...params} />,
    voltz: <BusinessFilterFormVoltz {...params} />,
  };

  return views[params?.flow] || views.default;
};

export default memo(BusinessFilterForm);
